import { axiosClient } from '../axiosClient';
import type { Log, LogLevel } from '@/types/log.types';

interface GetLogsParams {
  deviceId?: string;
  level?: LogLevel;
  dateRange?: {
    start: string;
    end: string;
  };
  page?: number;
  limit?: number;
}

interface GetLogsResponse {
  logs: Log[];
  total: number;
  page: number;
  limit: number;
}

export const getLogs = async (params?: GetLogsParams): Promise<GetLogsResponse> => {
  try {
    const response = await axiosClient.get('/logs', { params });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch logs:', error);
    throw error;
  }
};

export const exportLogs = async (params?: GetLogsParams): Promise<Blob> => {
  try {
    const response = await axiosClient.post('/logs/export', params, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Failed to export logs:', error);
    throw error;
  }
};
